import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import { fetchJacketDetail } from "@/components/SuperSearch/reportSectionsApi";
import { searchBookingsModule } from "@/components/SuperSearch/moduleSearchApi";
import { mergeFlagsIntoInvolvements } from "./flagUtils";

// Everything the header's folder-icon "Folder Details" modal shows, read
// from the folder (jacket) itself rather than from whichever booking happens
// to be open - mirrors ASP's JacketSupport_JacketDetails, which loads
// Jackets\Bio + the jacket's flags, and JacketsStandalone.asp's "Booking
// Records" list (Jackets\Bookings = every booking in the jacket).
//
//  - bio / masterTransactionDate:
//                    GET bookings/jackets/id/{jacketId}. Same endpoint Warrants'
//                    "move to folder" reads; the jacket comes back either
//                    wrapped as jackets[0] or bare, so both are accepted.
//  - cdInvolvements: GET flags/jacket/{jacketId} - the authoritative list of
//                    flags on the jacket (see mergeFlagsIntoInvolvements).
//  - bookings:       POST bookings/search filtered by jacketId - the same
//                    call SuperSearch's jacket report uses to list a
//                    jacket's bookings.
//
// Each part fails independently; `bio`/`cdInvolvements`/`bookings` come back
// null for whichever part failed so the caller can decide what to fall back
// to.
export const fetchFolderDetails = async (jacketId) => {
  const [jacketResult, flagsResult, bookingsResult] = await Promise.allSettled([
    fetchJacketDetail(jacketId),
    api.get(API_ENDPOINTS.getFlagByJacketID + jacketId).then((r) => r?.data),
    searchBookingsModule({
      requestFilter: [{ filterKey: "jacketId", value: String(jacketId) }],
      pagination: { pageIndex: 0, pageSize: 100 },
    }),
  ]);

  const response =
    jacketResult.status === "fulfilled" ? jacketResult.value : null;
  const jacket = response?.jackets?.[0] ?? response;

  return {
    bio: jacket?.bio?.[0] ?? null,
    masterTransactionDate: jacket?.masterTransactionDate ?? null,
    cdInvolvements:
      flagsResult.status === "fulfilled"
        ? mergeFlagsIntoInvolvements([], flagsResult.value)
        : null,
    bookings:
      bookingsResult.status === "fulfilled"
        ? bookingsResult.value?.rows || []
        : null,
  };
};
